__turbopack_context__.v({
  "accept": "SuggestedQuestionInput-module__eK5nNa__accept",
  "acceptAnchor": "SuggestedQuestionInput-module__eK5nNa__acceptAnchor",
  "field": "SuggestedQuestionInput-module__eK5nNa__field",
  "input": "SuggestedQuestionInput-module__eK5nNa__input",
  "suggestion": "SuggestedQuestionInput-module__eK5nNa__suggestion",
});
